import React from 'react';
import PropTypes from 'prop-types';
import { Box, Container, Typography } from '@mui/material';
import LazyLoad from 'react-lazyload';
import Video from 'components/Video';
import { useStyles } from './styles';

const Props = {
  textTitle: PropTypes.string.isRequired,
  textDescription: PropTypes.node,
};

export default function CreatingScienceIllustrationsMobile({ textTitle, textDescription }) {
  const classes = useStyles();

  return (
    <LazyLoad offset={100}>
      <Container>
        <Typography className={classes.title} component="h2">
          <b>{textTitle}</b>
        </Typography>

        {textDescription && (
          <Box pt={3} display="flex" justifyContent="center">
            <Typography variant="body2" component="p" align="flex-start">
              {textDescription}
            </Typography>
          </Box>
        )}

        <Box display="flex" justifyContent="center" alignItems="center">
          <Box className={classes.videoWrapper} pt={3}>
            <LazyLoad offset={50}>
              <Video
                className={classes.video}
                sources={[{ src: '/videos/institutions/illustrations.webm', type: 'video/webm' }]}
              />
            </LazyLoad>
          </Box>
        </Box>
      </Container>
    </LazyLoad>
  );
}

CreatingScienceIllustrationsMobile.propTypes = Props;
